import React, { Component } from "react";
import { cloneDeep } from "lodash";
import {Button, Col, Form, Input, InputNumber, Modal, Row, Select} from "antd";
import {
  BankOutlined,
  BarcodeOutlined,
  FundViewOutlined,
  UserOutlined,
  DollarCircleOutlined, UploadOutlined,
} from "@ant-design/icons";
import Resources from "../scripts/resources";
import Rules from "../scripts/rules";
import API from "../scripts/api";
import { Upload } from 'antd';
import {PlusOutlined, ProjectOutlined} from '@ant-design/icons';
import {Constants} from "../scripts/settings";
class UserJobsForm extends Component {
  constructor() {
    super();

    this.state = {
      data: [],
      fileList: []


    };

    this.formRef = React.createRef();
  }

  handleChange = () => {
    this.formRef.current.setFieldsValue({ subCategory: undefined });
  };

  handleSubmit = () => {
    this.setState({fileList: []})
    this.formRef.current.validateFields()
        .then(async values => {
          await this.props.onSubmit(values);
        });
  };

  handleWillUnmount = () => {
    this.setState({fileList: []})
    this.formRef.current.resetFields();
  };

  handleDidMount = async (data = {}) => {
    const cloneData = cloneDeep(data);

    this.setState({ editMode: !!cloneData._id, selected: data });

    this.formRef.current.setFieldsValue(cloneData);

  };

  handleChangeImage = (data) => {
    // this.setState({ fileList })

    if((data.file.status == "removed") && (data.file.originFileObj == undefined)){
      const params = { "imgId": data.file.uid}
    }

    this.setState({fileData: data.file})
  };

  handlePreview = async file => {
    if (!file.url && !file.preview) {
      file.preview = await this.getBase64(file.originFileObj);
    }
    this.setState({
        previewImage: file.url || file.preview,
        previewVisible: true,
        previewTitle: file.name || file.url.substring(file.url.lastIndexOf('/') + 1),
      });
  };

  getBase64 = (file) =>{
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = error => reject(error);
    });
  }

  render() {
    const {onCancel, submitting, visible } = this.props;
    const {editMode, fileList} = this.state;

    const props = {
      onRemove: file => {
        this.setState(state => {
          const index = state.fileList.indexOf(file);
          const newFileList = state.fileList.slice();
          newFileList.splice(index, 1);
          return { fileList: newFileList };
        });
      },
      beforeUpload: file => {
        this.setState({ fileList: [file], fileData: file });
        return false;
      },
      fileList
    };

    const uploadButton = (
        <div>
          <PlusOutlined />
          <div style={{ marginTop: 8 }}>Upload</div>
        </div>
    );

    return (
      <Modal
        title={Resources.edit}
        visible={visible}
        onOk={this.handleSubmit}
        onCancel={onCancel}
        okText={Resources.confirm}
        cancelText={Resources.cancel}
        okButtonProps={{ loading: submitting }}
        cancelButtonProps={{ disabled: submitting }}
        width={748}
      >
        <Form ref={this.formRef} layout="vertical">
          <Row gutter={24}>
            <Col xs={24}>
              <Form.Item
                name="title"
                label={`${Resources.title}`}
                rules={Rules.required}
              >
                <Input type="text" prefix={<UserOutlined />}  />
              </Form.Item>
            </Col>
            

            

          </Row>
        </Form>
      </Modal>
    );
  }
}

export default UserJobsForm;
